import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DefaultData {
    DefaultDataDetails: any;
}

interface DefaultDataState {
    value: DefaultData;
}

const initialState: DefaultDataState = {
    value :{
        DefaultDataDetails: [],
    }
};



const getDefaultDataSlice = createSlice({
  name: "getDefaultData",
  initialState: initialState,
  reducers: {
    setDefaultContent: (state,  action: PayloadAction<string>) => {
      state.value.DefaultDataDetails = action.payload;
    }    
  }
});

export const { setDefaultContent } = getDefaultDataSlice.actions;

export default getDefaultDataSlice.reducer;